import { render, staticRenderFns } from "./CropperFileUploader.vue?vue&type=template&id=be81984a&scoped=true&"
import script from "./CropperFileUploader.vue?vue&type=script&lang=js&"
export * from "./CropperFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./CropperFileUploader.vue?vue&type=style&index=0&id=be81984a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be81984a",
  null
  
)

export default component.exports